
import { Button, Icon } from '@brskl/ui-lib';
import { NoticeEnumTypes } from '@/core/data/Notice-enum';
import { defineComponent } from 'vue';
import { mapActions } from 'vuex';

export default defineComponent({
  emits: ['close'],

  components: {
    //@ts-ignore
    Icon,
    //@ts-ignore
    Button,
  },
  //@ts-ignore
  computed: {
    type() {
      return this.item?.type || NoticeEnumTypes.default;
    },

    isMessage() {
      return this.type === 'chat-message';
    },

    title() {
      return this.item?.title || '';
    },

    message() {
      if (this.type === 'error') {
        return !!this.item.message.error
          ? this.$t(this.item?.message.error.message)
          : this.$t('error_try_reload') || '';
      } else {
        return this.item?.message.substring(0, 120) || '';
      }
    },
  },

  props: {
    item: {
      type: Object,
    },
  },

  methods: {
    ...mapActions({
      setChat: 'core$notifications/setChat',
    }),
    onClose() {
      this.$emit('close', this.item.id);
    },
    autoClose() {
      setTimeout(this.onClose, 7000);
    },
    onChat() {
      this.onClose();
      this.setChat(true);
    },
  },

  mounted() {
    this.autoClose();
  },
});
